class Reply {
  private _code: ReplyCode;
  private _message: string;
  
  constructor(code: ReplyCode, message?: string) {
    this._code = code;
    this._message = message ? message : "";
  }

  static ok() : Reply {
    return new Reply(ReplyCode.OK);
  }

  static with(code: ReplyCode, message: string) : Reply {
    return new Reply(code, message);
  }

  get code() { return this._code; }
  get message() { return this._message; }

}

enum ReplyCode {
  OK,
  UNKNOWN,
  DELETE_FAILED_CHILD_DEPENDENCY,
  DELETE_FAILED_DATA_DEPENDENCY,
  DELETE_FAILED_IMMUTABLE_DEPENDENCY,
  UNIQUE_FIELD_CONSTRAINT,
}

export { Reply, ReplyCode };